import { render, staticRenderFns } from "./RateSocialSecurityModal.vue?vue&type=template&id=519bf613&scoped=true&"
import script from "./RateSocialSecurityModal.vue?vue&type=script&lang=js&"
export * from "./RateSocialSecurityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519bf613",
  null
  
)

export default component.exports